import {useMutation, useQueryClient} from "@tanstack/react-query";
import {useModal} from "../../../../../hooks";
import {AxiosError} from "axios";
import {uploadOverseasExcel} from "../../../../../api/main/OcApi";


export const useUploadOverseasExcel = () => {
    const {handleModal} = useModal();
    const qc = useQueryClient()

    const {mutate} = useMutation({
        mutationFn: (data: FormData) => uploadOverseasExcel(data),
        onSuccess: (res) => {
            const data = res.data

            if (data.code === "0000") {
                handleModal({
                    isOpen: true,
                    contents: data.msg,
                    type: "alert",
                });
                qc.invalidateQueries({queryKey: ["readOverseas"]})
            } else {
                handleModal({
                    isOpen: true,
                    contents: data.msg,
                    type: "alert",
                });
            }
        },
        onError: (error: AxiosError<{ msg?: string }>) => {
            if (error?.response?.data?.msg) {
                handleModal({
                    isOpen: true,
                    contents: error?.response?.data?.msg,
                    type: "alert",
                });
            }
        },
    });

    return {mutate};
};
